module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Anthony Trollope\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Anthony Trollope (1815–1882) was the author of over fifty books of fiction and nonfiction and is widely regarded as one of the preeminent English novelists of the Victorian era. Uncommon in his ability to capture both a wide readership and the highest respect of his most influential critics and peers—including luminaries such as Nathaniel Hawthorne, William Thackeray, Henry James, and George Eliot—Trollope is best remembered for two great sextets, the Chronicles of Barsetshire and the Pallisers, as well as his late-career satirical masterpiece "), _c('I', [_vm._v("The Way We Live Now")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HzgV9i/tc-custom/9781504065207.jpg?1737123916864",
      "alt": "This image is the cover for the book Chronicles of Barsetshire Volume One, The Chronicles of Barsetshire"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Chronicles of Barsetshire Volume One, The Chronicles of Barsetshire\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Three novels of life and death in a rural town in Victorian England by a master of drama and social satire.")]), _c('br'), _c('br'), _vm._v(" In the nineteenth century, Anthony Trollope created the fictional world of Barsetshire, the setting for a series of classic novels that addressed love, murder, religion, politics, and the ordinary lives of locals both rich and poor."), _c('br'), _c('br'), _c('i', [_vm._v("The Warden")]), _vm._v(": A well-meaning public official finds himself embroiled in a scandal."), _c('br'), _c('br'), _c('i', [_vm._v("Barchester Towers")]), _vm._v(": A bishop passes away, leading the town to become caught up in church politics."), _c('br'), _c('br'), _c('i', [_vm._v("Doctor Thorne")]), _vm._v(": A young noble is drawn to a woman, but his family is displeased by her lack of fortune and social standing, in this sweeping love story.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0